module.exports = __webpack_public_path__ + "static/media/arrow-right-arrow-left-solid.9d3203e1.svg";